import React from 'react';
import Grid from '@mui/material/Grid2';
import { TextField, Typography } from '@mui/material';

class AprovedTextInfo extends React.Component {
	state = { shouldRenderForm: false, };
	componentDidMount() {this.updateShouldRenderForm();}
	componentDidUpdate(prevProps) {
		if (prevProps.form !== this.props.form || prevProps.question !== this.props.question)
      this.updateShouldRenderForm();
	}
	shouldComponentUpdate(nextProps, nextState) {
		return (
			nextProps.form !== this.props.form ||
			nextProps.question !== this.props.question ||
			nextState.shouldRenderForm !== this.state.shouldRenderForm
		);
	}
  updateShouldRenderForm() {
    const { form, question } = this.props;
    const shouldRenderForm = form && form.reviewable && (question.approved === null || question.approved === false);
    this.setState({ shouldRenderForm });
  }
  render() {
    const {
      form,
      question,
      index,
      updateQuestionApprovedReason,
      lan,
      id,
    } = this.props;
    const { shouldRenderForm } = this.state;
    if (!shouldRenderForm) return null;
    return (
      <Grid container id={id} spacing={1} direction="row" sx={{ alignItems: "center", mt: 1 }}>
        <Grid size={2}>
          <Typography
            sx={(theme) => ({
              color: theme.palette.error.main,
              fontSize: 14,
              fontWeight: 500,
            })}
          >
            {lan.reasonForNotApproved}
          </Typography>
        </Grid>
        <Grid size={10}>
          <TextField
            size={'small'}
            defaultValue={question.notApprovedReason}
            multiline
            minRows={1}
            fullWidth
            variant="outlined"
            onChange={(e) =>
              updateQuestionApprovedReason(index, question, e.target.value)
            }
            slotProps={{
              input: {},
            }}
            sx={{
              '& .MuiInputBase-root': {
                alignItems: 'flex-start',
                padding: '5px 10px',
              },
            }}
          />
        </Grid>
      </Grid>
    );
  }
}
export default AprovedTextInfo;
//Original code:
/*import React from 'react';
import Grid from '@mui/material/Grid2';
import TextareaAutosize from 'react-textarea-autosize';
class AprovedTextInfo extends React.Component {
	state = { shouldRenderForm: false, };
	componentDidMount() {this.updateShouldRenderForm();}
	componentDidUpdate(prevProps) {
		if (prevProps.form !== this.props.form || prevProps.question !== this.props.question)
      this.updateShouldRenderForm();
	}
	shouldComponentUpdate(nextProps, nextState) {
		return (
			nextProps.form !== this.props.form ||
			nextProps.question !== this.props.question ||
			nextState.shouldRenderForm !== this.state.shouldRenderForm
		);
	}
  updateShouldRenderForm() {
    const { form, question } = this.props;
    const shouldRenderForm = form && form.reviewable && (question.approved === null || question.approved === false);
    this.setState({ shouldRenderForm });
  }
	render() {
    const { form, question, index, updateQuestionApprovedReason, lan, id } = this.props;
		const { shouldRenderForm } = this.state;
    return (
        shouldRenderForm && (
        <Grid container id={id} spacing={1}>
          <Grid size={2} className="reason-label" style={{color:'red'}}>{lan.reasonForNotApproved}</Grid>
          <Grid size={10} className="mt-2">
            <TextareaAutosize
              className="task-details-input"
              defaultValue={question.notApprovedReason}
              onChange={(e) =>
                updateQuestionApprovedReason(index, question, e.target.value)
              }
              style={{
                width: '100%',
                padding: '5px 10px',
              }}
            />
          </Grid>
        </Grid>
        )
    );
  }
}
export default AprovedTextInfo;
*/


